<div class="p-4">
  <div class="d-flex justify-content-between">
    <div class="card-sub-heading my-3 font_custom">Rx Details</div>
    <button mat-icon-button (click)="this.dialogRef.close()" type="button">
      <img src="assets/images/icons/grey_cross_icon.png" alt="close icon" />
    </button>
  </div>

  <div class="pagination-table mt-3" id="report_parameters" *ngIf="props?.sale_order_rx_detail.length else noData">
    <table class="table height" aria-describedby="Report Parameters Table">
      <thead>
        <tr>
          <th>RX ID</th>
          <th>Quantity</th>
          <th>Drug Name</th>
          <th>DIN</th>
          <th>Fill Date</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of props?.sale_order_rx_detail">
          <td>{{ item.RxNum }}</td>
          <td>{{ item.DispQty }}</td>
          <td>
            {{ item.kroll_drg?.GenericName || item.kroll_drg?.BrandName || 'N/A' }}
          </td>
          <td>{{ item.kroll_drg?.DIN }}</td>
          <td>{{ helperService.getSlashDate(item.FillDate) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <ng-template #noData>
    <div class="d-flex flex-column align-items-center w-100 mt-3 justify-content-center noDataFound">
      <img src="assets/images/emptystate.png" class="mb-3" alt="no data found icon" />
      <div class="semibold mb-1">No Data Found</div>
      <div>Data has not been found</div>
    </div>
  </ng-template>
</div>
